<template>
  <v-app-bar
    app
    color="white"
    elevation="0"
    style="padding-left: 4vw; padding-right: 4vw"
  >
    <div
      class="d-flex justify-space-between"
      style="width: 100%"
    >
      <div class="logo d-flex">
        <div class="logo-image mr-2" />
        <div class="logo-text mr-4">
          <div class="logo-title">
            Arztpraxis
          </div>
          <div class="logo-name">
            Dr med Szabó
          </div>
        </div>
        <div class="vertical-line mr-4" />
        <div class="logo-message">
          Akademische Lehrpraxis der UKE und MHH
        </div>
      </div>
      <div class="contact-info d-flex">
        <div
          v-for="(praxis, i) in praxisData"
          :key="i"
          class="d-flex"
        >
          <div>
            <div style="font-size: 1.1rem">
              {{ praxis.name }}
            </div>
            <h3 style="margin-top: -4px">{{ praxis.phone }}</h3>
          </div>
          <div
            v-if="i < praxisData.length - 1"
            class="vertical-line mr-4 ml-4"
          />
        </div>
      </div>
    </div>
    <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->
    <!-- <v-toolbar-title>My Website</v-toolbar-title> -->

    <!-- <v-spacer></v-spacer> -->

    <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->
    <!-- <v-navigation-drawer v-model="drawer" app> -->
      <!-- Add your navigation links here -->
      <!-- <v-list>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <!-- Add more navigation links as needed -->
      <!-- </v-list> -->
    <!-- </v-navigation-drawer> -->
  </v-app-bar>
</template>

<script>
export default {
  name: 'NavBar',

  data() {
    return {
      drawer: false,
    };
  },

  props: {
    praxisData: {
      type: Object,
      required: true,
    }
  }
};
</script>

<style scoped>
.logo {
  margin-top: 2px;
}

.logo-image {
  width: 45px;
  height: 45px;
  background-image: url('../assets/images/logo.png');
  background-size: 48px 48px;
  background-position: -1px -1px;
  border-radius: 5px;
}

.logo-text {
  font-weight: bold;
  font-size: 1.2rem;
}

.logo-title {
  color: var(--primary);
  font-family: 'Times New Roman', Times, serif;
}

.logo-name {
  color: red;
  font-family: 'Dancing Script', cursive;
  margin-top: -10px;
}


.logo-message {
  color: red;
  width: 170px;
  font-size: 0.9rem;
  margin-top: 2px;
}

@media screen and (max-width: 1100px) {
  .logo-message {
    width: 100px;
    font-size: 0.7rem;
    margin-top: -2px;
  }
}

.vertical-line {
  width: 1px;
  height: 45px;
  background-color: var(--primary);
}

h3 {
  color: var(--primary);
}

@media screen and (max-width: 1100px) {
  .contact-info {
    display: none !important;
  }
}
</style>
